import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';
import {
	useSelector,
} from 'react-redux';

import SitemapsTable from './SitemapsTable';

import {
	loadData as loadSitemaps,
	selector as sitemapsSelector,
} from '~/state/orphanedSitemaps';



const messages = defineMessages({
	url: {
		id: 'ui.screen.sitemapsList.headings.sitemap.label',
	},
});



type Props = {
	tableWidth: number,
};

const OrphanedSitemapsTable: React.FC<Props> = (props) => {
	const {
		tableWidth,
	} = props;

	const sitemaps = useSelector(sitemapsSelector);

	return (
		<SitemapsTable
			columns={[
				{
					render: {
						cell: ({ row }) => row.url,
						header: () => <FormattedMessage {...messages.url} />,
					},
					width: 500,
				},
			]}
			loadData={loadSitemaps}
			sitemaps={sitemaps}
			tableWidth={tableWidth}
		/>
	);
};



export default OrphanedSitemapsTable;
